import React from 'react';
import InlineTextField from '../components/InlineTextField';
import ModulePills from "../components/ModulePills";

const Article = (props) => {

    const handleErpIdnoChange = (newErpIdno) => {
        props.updateErpIdno(props.gtin, newErpIdno);
    };

    const handleGtinChange = (gtin) => {
        props.updateGtin(props.gtin, gtin);
    };

    const handleNameChange = (name) => {
        props.updateName(props.gtin, name);
    };

    const handleVendorArticleNumberChange = (vendorArticleNumber) => {
        props.updateVendorArticleNumber(props.gtin, vendorArticleNumber);
    };

    return (
        <tr>
            <td title={"Zum Bearbeiten klicken"}><InlineTextField value={props.erpIdno} onCommit={handleErpIdnoChange}/></td>
            <td title={"Zum Bearbeiten klicken"}><InlineTextField value={props.gtin} onCommit={handleGtinChange} width='150px'/></td>
            <td title={"Zum Bearbeiten klicken"}><InlineTextField value={props.name} onCommit={handleNameChange} width='300px'/></td>
            <td title={"Zum Bearbeiten klicken"}>
                <InlineTextField value={props.vendorArticleNumber} onCommit={handleVendorArticleNumberChange}/>
            </td>
            <td>{props.brand}</td>
            <td><ModulePills gtin={props.gtin}/></td>
        </tr>
    )

};

export default Article;


// WEBPACK FOOTER //
// ./src/admin/article/Article.js